import angular from 'angular'

import templateUrl from './transfer-onboarding-application.html'

export const TransferOnboardingApplicationModalComponent = {
    controller: TransferOnboardingApplicationController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}

export const TransferOnboardingApplicationModal = {
    component: "apexTransferOnboardingApplication",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
}

function TransferOnboardingApplicationController(employeeService, onboardingApplicationService,
    utilityService, icdCorporationService) {
    'ngInject'

    const vm = this;
    vm.$onInit = onInit;
    vm.employment;
    vm.onboardingApplication;
    vm.isAdminView;
    vm.onCancel = onCancel;
    vm.editForm;
    vm.errors = [];
    vm.onChangeType = onChangeType;
    vm.onChangeEffectiveDate = onChangeEffectiveDate;
    vm.employee;
    vm.onChangeOffice = onChangeOffice;
    vm.employeeList;
    vm.onSave = onSave;

    return;

    function onInit() {

        vm.onboardingApplication = angular.copy(vm.resolve.onboardingApplication);
        vm.isAdminView = vm.resolve.isAdminView;
        vm.sgiAssignmentHistories = vm.resolve.sgiAssignmentHistories;
        vm.isValid = vm.sgiAssignmentHistories.length > 0;

        if (vm.isValid) {
            const activetHistory = vm.sgiAssignmentHistories.sort(function (a, b) {
                if (a.ActiveStart > b.ActiveStart) {
                    return -1;
                }
                if (a.ActiveStart < b.ActiveStart) {
                    return 1;
                }
                return 0;
            })[0];

            if (activetHistory) {
                const date = activetHistory.ActiveEnd ? activetHistory.ActiveEnd : activetHistory.ActiveStart;
                const result = new Date(date);
                result.setDate(result.getDate() + 1);
                vm.minAllowedDate = result;
            }


        }
        vm.employee = vm.resolve.employee;
        loadInitialData();
    }

    function loadInitialData() {

        utilityService.showLoading();
        icdCorporationService.retrieveModuleAdminIcdOffices()
            .then(function (offices) {
                vm.icdOffices = offices.map(function (icdOffice) {
                    icdOffice.Text = icdOffice.IcdCorporationName + " - " + icdOffice.OfficeName;
                    return icdOffice;
                });
                vm.icdOffices.sort(function (a, b) {
                    return a.Text.localeCompare(b.Text);
                });
            }).catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            }).then(utilityService.hideLoading);
    }

    function onChangeType() {

    }

    function onChangeEffectiveDate() {

    }

    function onChangeOffice() {

        utilityService.showLoading();
        employeeService.retrieveEmployees({ IcdOfficeID: vm.transfer.IcdOfficeID })
            .then(function (employees) {
                vm.employeeList = employees.map(function (employee) {
                    employee.Text = employee.FirstName + " " + employee.LastName;
                    return employee;
                });
            }).catch(function (ex) {

                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(utilityService.hideLoading);
    }
    function onCancel() {
        vm.dismiss({ $value: 'cancel' });
    }

    function onSave() {
        const request = {
            OnboardingApplicationID: vm.onboardingApplication.OnboardingApplicationID,
            TransferDate: vm.transfer.EffectiveDate
        };

        if (vm.TransferType.value === 'New') {

            utilityService.showLoading();
            employeeService.saveEmployee(vm.employee)
                .then(function (employee) {
                    request.IcdOfficeID = employee.IcdOffices[0].IcdOfficeID;
                    request.EmployeeID = employee.Id;
                    return employee;
                })
                .then(function () {
                    return onboardingApplicationService.transferOnboardingApplication(
                        request.OnboardingApplicationID, request)
                })
                .then(function () {

                    vm.close();
                    utilityService.hideLoading();
                })
                .catch(function (ex) {
                    console.error(ex);
                    alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                    utilityService.hideLoading();
                });

        } else if (vm.TransferType.value === 'Existing') {
            request.IcdOfficeID = vm.transfer.IcdOfficeID;
            request.EmployeeID = vm.transfer.EmployeeID;
            utilityService.showLoading();
            onboardingApplicationService.transferOnboardingApplication(request.OnboardingApplicationID, request)
                .then(function () {
                    vm.close();
                    utilityService.hideLoading();
                })
                .catch(function (ex) {
                    console.error(ex);
                    alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                    utilityService.hideLoading();
                    throw ex;
                });

        }

    }
}
